import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, ListGroup, Image, Card } from 'react-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetTransferDetailsQuery } from '../slices/transfersApiSlice';
import TransferCarousel from '../components/TransferCarousel';

const TransferScreen = () => {
  const { id: transferId } = useParams();

  const { data: transfer, refetch, isLoading, error } = useGetTransferDetailsQuery(transferId);

  useEffect(() => {
    if (!transfer) {
      refetch();
    }
  }, [transfer, refetch]);

  return isLoading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error?.data?.message || error.error}</Message>
  ) : (
    <>
      <h1>Transfer {transfer?._id}</h1>
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>Customer Details</h2>
              <p>
                <strong>Name: </strong> {transfer?.customerDetails?.name || 'N/A'}
              </p>
              <p>
                <strong>Company: </strong> {transfer?.customerDetails?.company || 'N/A'}
              </p>
              <p>
                <strong>Phone: </strong> {transfer?.customerDetails?.telephone || 'N/A'}
              </p>
              <p>
                <strong>Address: </strong> {transfer?.customerDetails?.address || 'N/A'}
              </p>
              <p>
                <strong>Serial: </strong> {transfer?.customerDetails?.serialNumber || 'N/A'}
              </p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Transfer Note</h2>
              <p>{transfer?.note || 'No additional notes provided'}</p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Transfer Items</h2>
              {transfer?.transferItems?.length === 0 ? (
                <Message>This transfer has no items</Message>
              ) : (
                <ListGroup variant="flush">
                  {transfer?.transferItems?.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          <Image
                            src={item?.images?.[0] || 'https://via.placeholder.com/40'}
                            alt={item?.name || 'Unnamed'}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col>
                          <strong>{item?.name || 'Unnamed'}</strong>
                        </Col>
                        <Col md={4}>
                          {item?.qty || 0} x ${item?.price || 0} = $
                          {(item?.qty || 0) * (item?.price || 0)}
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2>Transfer Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Date</Col>
                  <Col>{transfer?.date?.substring(0, 10) || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Total</Col>
                  <Col>${transfer?.totalPrice || 0}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Status</Col>
                  <Col>{transfer?.status || 'N/A'}</Col>
                  <Col>{transfer?.username || 'No user name provided'}</Col>
                  <Col md={6}>
                                              {/* Display expense images using TransferCarousel */}
                                              {transfer.images && transfer.images.length > 0 ? (
                                                <TransferCarousel images={transfer.images} />
                                              ) : (
                                                <Message variant="info">No images available for this expense</Message>
                                              )}
                   </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default TransferScreen;